import React from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Divider from 'material-ui/Divider';

import Hero from './Hero';
import Editor from './Editor';
import PrepregThickness from './PrepregThickness';
import Impedance from './Impedance';
import Footer from './Footer';
import SignupDialog from './SignupDialog';

const styles = theme => ({
  root: {
    flex: '1 0 100%',
  },
  steps: {
    maxWidth: theme.spacing.unit * 130,
    margin: 'auto',
  },
  step: {
    padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px`,
  },
  stepIcon: {
    marginBottom: theme.spacing.unit,
  },
  markdownElement: {},
});

export class PageHome extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  
  handleClickOpen() {
    this.setState({ open: true });
  };

  handleClose() {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    const { open } = this.state;

    return (
      <div className={classes.root}>
        <SignupDialog open={open} onClose={this.handleClose} />
        <Hero onButtonClick={this.handleClickOpen} />
        <Editor onButtonClick={this.handleClickOpen} />
        <Divider />
        <PrepregThickness onButtonClick={this.handleClickOpen} />
        <Divider />
        <Impedance onButtonClick={this.handleClickOpen} />
        <Footer />
      </div>
    );
  }
}

PageHome.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles))(PageHome);


// WEBPACK FOOTER //
// ./src/components/HomePage/Iteq/Home.jsx